import { useEffect } from 'react'
import { isNull } from '../../../utils/validator';
import { useFormErrors } from '../../hooks/useFormErrors';
import { useForm } from '@laramie/ui';
import { InputNumber, DatePickerCustom, Modal, FormLabel, FormError } from '../../common'
import { CloneObject } from '../../../utils/helpers'
const RubroAlicuotaModal = (props) => {

    const [formValues, formHandle, , formSet] = useForm({
        valor: 0,
        fechaDesde: null,
        fechaHasta: null,
    })

    useEffect(() => {
        formSet({
            valor: props.alicuota.valor,
            fechaDesde: props.alicuota.fechaDesde,
            fechaHasta: props.alicuota.fechaHasta,
        })
    }, [props.alicuota])

    const { errorOf, validate } = useFormErrors(getErrors, getFormatErrors)

    function getErrors() {
        const errors = {}

        if (formValues.valor <= 0) errors.valor = 'Ingresá un número mayor a cero'

        return errors
    }

    function getFormatErrors() {
        const errors = {}

        if (esRangoSolapado()) errors.fechaDesde = 'El rango se superpone con otro'

        return errors
    }

    function esRangoSolapado() {
        const rango = props.rangoSolapado
        return !isNull(rango)
            && sonLaMismaFecha(rango.fechaDesde, formValues.fechaDesde)
            && sonLaMismaFecha(rango.fechaHasta, formValues.fechaHasta)
    }

    function sonLaMismaFecha(una, otra) {
        if (isNull(una) || isNull(otra)) return isNull(una) && isNull(otra)
        return una.getTime() === otra.getTime()
    }

    const handleConfirm = () => {
        if (!validate()) return

        let row = CloneObject(props.alicuota)
        row.valor = formValues.valor
        row.fechaDesde = formValues.fechaDesde
        row.fechaHasta = formValues.fechaHasta

        props.onConfirm(row)
    }

    return (
        <Modal
            onEscape={props.onDismiss}
            title="Alícuota"
            size="lg"
            body={(
                <div className="row form-basic">
                    <div className="col-12 col-md-4">
                        <FormLabel htmlFor="valor" required>Valor</FormLabel>
                        <InputNumber
                            name="valor"
                            precision={2}
                            className={`form-control ${errorOf('valor') ? 'is-invalid' : ''}`}
                            value={formValues.valor}
                            onChange={formHandle}
                            disabled={props.disabled}
                        />
                        <FormError message={errorOf('valor')} />
                    </div>
                    <div className="col-12 col-md-4">
                        <label htmlFor="fechaDesde" className="form-label">Fecha desde</label>
                        <DatePickerCustom
                            name="fechaDesde"
                            placeholder=""
                            className={`form-control ${errorOf('fechaDesde') ? 'is-invalid' : ''}`}
                            value={formValues.fechaDesde}
                            onChange={formHandle}
                            disabled={props.disabled}
                        />
                        <FormError message={errorOf('fechaDesde')} />
                    </div>
                    <div className="col-12 col-md-4">
                        <label htmlFor="fechaHasta" className="form-label">Fecha hasta</label>
                        <DatePickerCustom
                            name="fechaHasta"
                            placeholder=""
                            className="form-control"
                            value={formValues.fechaHasta}
                            onChange={formHandle}
                            disabled={props.disabled}
                            minValue={formValues.fechaDesde}
                        />
                        <FormError />
                    </div>
                </div>
            )}
            footer={(
                <div className="width-100p disp-b">
                    <button className="btn back-button m-left-5" data-dismiss="modal" onClick={props.onDismiss}>Volver</button>
                    {!props.disabled && (
                        <button className="btn action-button" data-dismiss="modal" onClick={handleConfirm}>Aceptar</button>
                    )}
                </div>
            )}
        />
    )
}

export default RubroAlicuotaModal
